/*
 * Version of Statement specific to reseller
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid } from '@mui/material';
import { TablePagination, Typography, Table,  TableBody, TableCell, TableRow, Tooltip  } from '@mui/material';
import GetApp from '@mui/icons-material/GetApp';
import VendorStatementLines from './VendorStatementLines';
import StatementSelect from './StatementSelect';
import VendorStatementLinesFetch from './VendorStatementLinesFetch';
import HelpOutline from '@mui/icons-material/HelpOutline';

import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';
import AppBindStyles from '../../AppBindStyles';
import { format } from 'date-fns';

const abEnvironment = new AbEnvironment();
const VendorStatementQuery = graphql`
query VendorStatementQuery($vAccountId: UUID, $startDate: Datetime, $endDate: Datetime, $first: Int, $offset: Int) {
  getvendorstatementlines(vaccountid: $vAccountId, startts: $startDate, endts: $endDate, first: $first, offset: $offset) {
    totalCount
    nodes {
      beginningBalance
      paymentIn
      receivedIn
      chargeOut
      payoutOut
      endingBalance
      rowPurpose
      billTransactionId
      billTransactionTime
      billTransactionType
      recvTransactionId
      recvTransactionTime
      recvTransactionType
      revTransactionId
      revTransactionTime
      revTransactionType
      resellerAccountId
      resellerAccountName
      resellerPId
      resellerProgramName
      vendorPayoutId
      vendorPayoutStart
      vendorPayoutEnd
      vendorPayoutStatus
      payoutAmount
      feeAmount
      vendorBillTotal
      vendorConfAmount
      vendorRevAmount
      balance
    }
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
      //marginTop: 10,
    },
    flex: {
      flex: 1,
    },
    downloadButton: {
      marginTop: '0px' // Adjust to align better with text
      // marginLeft: theme.spacing(1),
      // marginTop: '20px',
      // marginBottom: theme.spacing(1),
    },
    dateField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: 4,
      width: 180,
    },
    textField2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: 3,
      width: 160,
    },
    textFieldSearch: {
      marginRight: theme.spacing(1),
      marginTop: 3,
      marginLeft: 0,
      width: 300,
    },
      paper1: {
      padding: 16,
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    paper2: {
      padding: 12,
      textAlign: 'left',
      color: theme.palette.text.secondary,
    },
    paper3: {
      padding: 16,
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    tblWidth: {
      maxWidth: 340,
    },
    tblCellWidth120: {
      width: 120,
      borderBottom: 0,
      padding: '2px 28px 2px 12px',
    },
    tblCellWidth80: {
        width: 60,
        borderBottom: 0,
        padding: '2px 8px 2px 8px',
    },
    tblCellTt: {
        width: 32,
        borderBottom: 0,
        padding: '2px 8px 2px 8px',
    }
});

class VendorStatement extends Component {

  constructor(props) {
    super(props);

    this.state = {
      statementIndex: 0,
      startDate: null,
      endDate: null,
      siId: null,
      vAccountId: this.props.vAccountId,
      page: 0,
      rowsPerPage: 10,
    };  
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      page: 0,
    });
  };

  setStatementSelectState = (idx, startTs, endTs, siId) => {
    let statementStorage = idx + '|' + startTs + '|' + endTs;
    localStorage.setItem('lastStatement', statementStorage);
    this.setState({ statementIndex: idx, startDate: startTs, endDate: endTs, siId: siId, page: 0});
  }

  handleChangePage = (event, page) => {
    this.setState({page: page});
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page : 0});
  }

  // The download needs to do another query in case there is more data for
  // the range than is shown on the screen.
  /*
  downloadCsv(startDate, endDate, vAccountId, first, offset) { 
    alert('startDate is ' + startDate);
  }
  */
  downloadCsv(startDate, endDate, vAccountId, first, offset) { 

    const { logError } = this.props.auth;

    var endDateStr;
    if (endDate == null) {
      endDateStr = format(new Date(), 'yyyy-MM-dd');
    } else {
      endDateStr = format(new Date(endDate), 'yyyy-MM-dd');
    }
    VendorStatementLinesFetch.fetch(vAccountId, startDate, endDate, first, offset).toPromise()
    .then(sl => {
      let theCount = sl.getvendorstatementlines.totalCount;
      if (theCount < 1) {
        return;
      }
      let thenodes = sl.getvendorstatementlines.nodes;
      let csv;

      csv = 'Date,Period,Reseller,Reseller Program,Payout,AppBind,Payment,Received,Balance\n';
      thenodes.map(n=> {
        let thePurpose = n.rowPurpose;
        let transDate;
        let payoutAmount = '';
        let feeAmount = '';
        let paidAmount = '';
        let pStart = format(new Date(n.vendorPayoutStart), 'MMM yyyy');
        let receivedAmount = '';
        let reseller = n.resellerAccountName;
        let program = n.resellerProgramName;

        //looks like "purpose" is for payment, payout, or other.
        //  FundingSources as reference, also some queries.
        if (thePurpose === 0) {
          transDate = format(new Date(n.billTransactionTime), 'yyyy-MM-dd');
          payoutAmount = '(' + Number(n.payoutAmount).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
          feeAmount = '(' + Number(n.feeAmount).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
          if (n.vendorConfAmount != null) {
            let theAmt = Number(n.vendorConfAmount) * -1;
            paidAmount = Number(theAmt).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
          }
        } else if (thePurpose === 1) {
          transDate = format(new Date(n.revTransactionTime), 'yyyy-MM-dd');
          receivedAmount = Number(n.vendorRevAmount).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
        } else {
          transDate = format(new Date(n.billTransactionTime), 'yyyy-MM-dd');
          pStart = 'Balance payout';
          reseller = '';
          program = '';
          if (n.vendorConfAmount != null) {
            let theAmt = Number(n.vendorConfAmount);
            if (theAmt < 0) {
              theAmt = theAmt * -1;
              paidAmount = '(' + Number(theAmt).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
            } else {
              paidAmount = Number(theAmt).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
            }
          }
        }
        
        let balance = null;

        // let vendorBillTotal = '(' + Number(n.vendorBillTotal).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
        // Balance is on all
        if (n.balance < 0) {
          let tbal = n.balance * -1;
          balance = '(' + Number(tbal).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
        } else {
          balance = Number(n.balance).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
        }


        let csvline = '' + transDate + ',' + pStart + ',' + reseller + ','
                         + program + ',' +  payoutAmount  + ','
                         + feeAmount + ',' + paidAmount + ','   + receivedAmount + ',' + balance  + '\n';
        csv = csv + csvline;
        return(null);
      });

      var downloadName = 'AppBind-Statement-' + endDateStr + '.csv';
      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      hiddenElement.download = downloadName;
      hiddenElement.click(); 
    })
    .catch(err => {
      logError('Exception in VendorStatement.js: ' + err);
    });
    
  }

  render() {
    const { isAuthenticatedVendor, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    if (!isAuthenticatedVendor() || needAssent()) { 
      return ( <Redirect to='/home' /> );
    }    

    // Determine the offset
    let offset = 0;
    if (this.state.page > 0)
    {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;

    let totalCount = 0;

    let selectAccountId = this.state.vAccountId;

    let selectedIndex = this.state.statementIndex;
    let selectedStart = this.state.startDate;
    let selectedEnd = this.state.endDate;

    let savedStatementSearch = localStorage.getItem('lastStatement');
    if (savedStatementSearch) {
      let search = savedStatementSearch.split("|");
      selectedIndex = search[0];
      selectedStart = search[1];
      selectedEnd = search[2];
    }

    let showDownloadButton = true;
    return (
      <div className={classes.root}>
        <Grid container spacing={2} direction="row" justifyContent="space-between" alignItems="center">
          <Grid item>
            <StatementSelect
              setStatementSelectState={this.setStatementSelectState}
              accountId={selectAccountId}
              statementIndex={selectedIndex}
              widthOverride={270}
            />
          </Grid>
          { showDownloadButton &&
          <Grid item>
            <Button
              color="primary"
              variant="contained"
              className={classes.downloadButton}
              onClick={() => 
                this.downloadCsv(selectedStart, selectedEnd, this.state.vAccountId, 10000, 0)
              }
            >
              Download Statement&nbsp;&nbsp;<GetApp/>
            </Button>
          </Grid>
          }
        </Grid>
        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={VendorStatementQuery}
          variables={{vAccountId: this.state.vAccountId,
                      startDate: selectedStart,
                      endDate: selectedEnd,
                      first: first,
                      offset: offset}}
          render={({error, props})=> {
            if (error) {
              logError(error.message);
              return (
                <ServerError/>
              );
            } else if (props) {
              // Determine offset information
              totalCount = props.getvendorstatementlines.totalCount;

              let beginningBalance = 0;
              let paymentIn = 0;
              let receivedIn = 0;
              let chargeOut = 0;
              let payoutOut = 0;
              let endingBalance = 0;
              if (totalCount > 0) {
                let firstNode = props.getvendorstatementlines.nodes[0];

                if (firstNode.beginningBalance)
                  beginningBalance = firstNode.beginningBalance;
                if (firstNode.payoutOut)
                  payoutOut = firstNode.payoutOut * -1;
                if (firstNode.chargeOut)
                  chargeOut = firstNode.chargeOut * -1;
                if (firstNode.paymentIn)
                  paymentIn = firstNode.paymentIn;
                if (firstNode.receivedIn)
                  receivedIn = firstNode.receivedIn;
                if (firstNode.endingBalance)
                  endingBalance = firstNode.endingBalance;
              }
              let beginningBalanceF = Number(beginningBalance).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
              let paymentInF        = Number(paymentIn).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
              let receivedInF       = Number(receivedIn).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
              let chargeOutF        = Number(chargeOut).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
              let payoutOutF        = Number(payoutOut).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
              let endingBalanceF    = Number(endingBalance).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

              return (
                <Grid container spacing={1} direction="row" justifyContent="flex-start">
                  <Grid item xs={12}>
                    <Typography variant="h6" style={AppBindStyles.sectionTitle}>
                      Statement summary
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Table className={classes.tblWidth}>
                      <TableBody>
                        <TableRow>
                          <TableCell className={classes.tblCellWidth120}><Typography variant="body1">Beginning balance</Typography></TableCell>
                          <TableCell align="right" className={classes.tblCellWidth80}><Typography variant="body1">{beginningBalanceF}</Typography></TableCell>
                          <TableCell className={classes.tblCellTt}>
                            <Tooltip placement='right' title='Your AppBind balance is the amount available in your AppBind account to payout rebates to resellers. This is your balance at the beginning of the statement period.'>
                              <HelpOutline fontSize="small" style={{verticalAlign: "-8%"}}/>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className={classes.tblCellWidth120}><Typography variant="body1">Payouts</Typography></TableCell>
                          <TableCell align="right" className={classes.tblCellWidth80}><Typography variant="body1">{payoutOutF}</Typography></TableCell>
                          <TableCell className={classes.tblCellTt}>
                            <Tooltip placement='right' title='This is the amount paid out to resellers.'>
                              <HelpOutline fontSize="small" style={{verticalAlign: "-8%"}}/>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className={classes.tblCellWidth120}><Typography variant="body1">Fees</Typography></TableCell>
                          <TableCell align="right" className={classes.tblCellWidth80}><Typography variant="body1">{chargeOutF}</Typography></TableCell>
                          <TableCell className={classes.tblCellTt}>
                            <Tooltip placement='right' title='This is the amount you have paid for AppBind fees.'>
                              <HelpOutline fontSize="small" style={{verticalAlign: "-8%"}}/>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className={classes.tblCellWidth120}><Typography variant="body1">Payments</Typography></TableCell>
                          <TableCell align="right" className={classes.tblCellWidth80}><Typography variant="body1">{paymentInF}</Typography></TableCell>
                          <TableCell className={classes.tblCellTt}>
                            <Tooltip placement='right' title='This is the amount of payments that you have made to AppBind to cover reseller rebates and AppBind fees, less any refunded commissions.'>
                              <HelpOutline fontSize="small" style={{verticalAlign: "-8%"}}/>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className={classes.tblCellWidth120}><Typography variant="body1">Received</Typography></TableCell>
                          <TableCell align="right" className={classes.tblCellWidth80}><Typography variant="body1">{receivedInF}</Typography></TableCell>
                          <TableCell className={classes.tblCellTt}>
                            <Tooltip placement='right' title='This is the revenue you received from sellers through AppBind, including rebate reversals.'>
                              <HelpOutline fontSize="small" style={{verticalAlign: "-8%"}}/>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className={classes.tblCellWidth120}><Typography variant="body1">Ending balance</Typography></TableCell>
                          <TableCell align="right" className={classes.tblCellWidth80}><Typography variant="body1">{endingBalanceF}</Typography></TableCell>
                          <TableCell className={classes.tblCellTt}>
                            <Tooltip placement='right' title='This is your balance at the at the end of the statement period.'>
                              <HelpOutline fontSize="small" style={{verticalAlign: "-8%"}}/>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="h6" style={AppBindStyles.sectionTitle}>
                      Transactions
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <VendorStatementLines cl={props.getvendorstatementlines} history={this.props.history}/>
                  </Grid>
                  <Grid item xs={12}>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, 50]}
                      component="div"
                      count={totalCount}
                      rowsPerPage={this.state.rowsPerPage}
                      page={this.state.page}
                      backIconButtonProps={{
                        'aria-label': 'Previous Page',
                      }}
                      nextIconButtonProps={{
                        'aria-label': 'Next Page',
                      }}
                      onPageChange={this.handleChangePage}
                      onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />                        
                  </Grid>
                </Grid>
              )
            }
            return (
              <LoadingSpinner />
            );
          }}
        />
      </div>
    );
  }
}
  
VendorStatement.propTypes = {
  classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(VendorStatement);
